import * as linkConst from '../../constants/link_constants'
import ArchiveStores from './archive'
import ArtistsStores from './artists'
import CReportsStores from './creports'
import ClientsStores from './clients'
import ContractTimeRestStores from './contract_time_restrictions'
import ContractsStores from './contracts'
import EnumSetStores from './enum_settings'
import FPVCategoriesStores from './fpv_categories/fpv_categories'
import FPVSettingStores from './fpv_settings/fpv_settings'
import FPVTestingStores from './fpv_testing'
import FilmcargoHelpStores from './filmcargo_help'
import FilmsStores from './films'
import FinancialReportsStores from './financial_reports'
import PPRollsSetupStores from './pprolls'
import PPRollsUploadStores from './uploading'
import PricingsStores from './pricing'
import RatingStores from './rating'
import RightsStores from './rights'
import VATratesStores from './vatrates'
import XRatesStores from './xrates'
import YTAssetssStores from './youtube_assets'

export default (store) => {
  const manip = {}
  const list = {}

  function _add (attr, ClassInit) {
    const klassews = ClassInit(store)
    manip[attr] = klassews.ManipState
    list[attr] = klassews.TableState
  }

  _add(linkConst.LINK_ARCHIVE, ArchiveStores)
  _add(linkConst.LINK_CATEGORIES, FPVCategoriesStores)
  _add(linkConst.LINK_CATEG_SETTINGS, EnumSetStores)
  _add(linkConst.LINK_CLIENTS, ClientsStores)
  _add(linkConst.LINK_CONTRACTS, ContractsStores)
  _add(linkConst.LINK_CONTRACT_TIME_RESTRICTIONS, ContractTimeRestStores)
  _add(linkConst.LINK_FILMCARGO_HELP, FilmcargoHelpStores)
  _add(linkConst.LINK_FILMS, FilmsStores)
  _add(linkConst.LINK_FINANCIAL_REPORTS, FinancialReportsStores)
  _add(linkConst.LINK_FPVTESTING, FPVTestingStores)
  _add(linkConst.LINK_PERSONS, ArtistsStores)
  _add(linkConst.LINK_PPROLLS_SETUP, PPRollsSetupStores)
  _add(linkConst.LINK_PPROLLS_UPLOAD, PPRollsUploadStores)
  _add(linkConst.LINK_PRICING, PricingsStores)
  _add(linkConst.LINK_RATING, RatingStores)
  _add(linkConst.LINK_REPORTS, CReportsStores)
  _add(linkConst.LINK_RIGHTS, RightsStores)
  _add(linkConst.LINK_SETTINGS, FPVSettingStores)
  _add(linkConst.LINK_TIERS_SETTINGS, EnumSetStores)
  _add(linkConst.LINK_VATRATES, VATratesStores)
  _add(linkConst.LINK_XRATES, XRatesStores)
  _add(linkConst.LINK_YOUTUBE_ASSETS, YTAssetssStores)

  _add(linkConst.LINK_ENUMS, EnumSetStores)

  return { manip, list }
}
